export const COMMENT_ZONE = 'comment_zone';
